import { createFileRoute } from "@tanstack/react-router";
import { safeJsonLd } from "@/lib/structured-data";
import { bookingPageCrumbs, getClinicStructuredData } from "@/lib/structured-data/clinic";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AcuityEmbed } from "@/components/site/AcuityEmbed";
import { AcuityConversionListener } from "@/components/site/AcuityConversionListener";

// Booking page for the Fulton Market, Chicago clinic (159 N Sangamon St, Suite 200, Chicago, IL 60607). The clinic has no
// appointment type of its own in Acuity. The embed opens the public "Illinois
// Locations" type (26951941) with calendarID=7437420, which limits the
// scheduler to this one clinic calendar.
export const Route = createFileRoute("/schedule-a-consult/fulton-market")({
  head: () => ({
    meta: [
      // Indexable since 3 Oct 2026, as on the old production site (Wayback
      // 2025 shows "index, follow"). The sitemap lists this page.
      { title: "Schedule FREE Hair Consultation in Fulton Market, Chicago" },
      {
        name: "description",
        content:
          "Schedule a free hair restoration consult with RESTORE in Fulton Market, Chicago, in person or by video. Our client advisors will answer your questions.",
      },
      {
        property: "og:title",
        content: "Schedule FREE Hair Consultation in Fulton Market, Chicago",
      },
      {
        property: "og:description",
        content:
          "Book a free in-person or virtual hair restoration consultation with RESTORE in Fulton Market, Chicago.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://restorehair.com/schedule-a-consult/fulton-market/",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: safeJsonLd({
          "@graph": getClinicStructuredData("fulton-market", bookingPageCrumbs("Fulton Market", "/schedule-a-consult/fulton-market/")),
        }),
      },
    ],
  }),
  component: ScheduleFultonMarketPage,
});

function ScheduleFultonMarketPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-5xl px-4 py-10 md:py-14">
        <h1 className="text-center text-3xl font-normal text-foreground md:text-5xl">
          Schedule Your <strong className="font-extrabold">FREE</strong> Hair Consultation
        </h1>
        <p className="mt-4 text-center text-base text-muted-foreground md:text-lg">
          Select a time for a free hair transplant consultation in Fulton Market, Chicago
        </p>
        <AcuityConversionListener />
        <div className="mt-8">
          <AcuityEmbed src="https://app.acuityscheduling.com/schedule.php?owner=24213130&appointmentType=26951941&calendarID=7437420" />
        </div>
      </main>
      <Footer />
    </div>
  );
}
